import React from "react";

const Navbar = () => (
	<nav className="bg-white shadow-md sticky top-0 z-50">
		<div className="max-w-6xl mx-auto px-4 py-1 flex justify-between items-center">
			<div className="flex items-center space-x-4">
				<img src="./assets/lightyear.jpg" alt="" className="w-[80px]" />
				{/* <h1 className="text-2xl font-bold text-teal-600">Trivnet Services</h1> */}
			</div>

			<div className="space-x-6">
				<a href="#about" className="hover:text-teal-600">
					About
				</a>
				<a href="#services" className="hover:text-teal-600">
					Services
				</a>
				<a href="#contact" className="hover:text-teal-600">
					Contact
				</a>
			</div>
		</div>
	</nav>
);

export default Navbar;
